module.exports = __webpack_public_path__ + "img/tous-les-details.6e97087b.svg";